/**
 * Maximum practical client-side content protection.
 * Note: nothing stops DevTools from a determined user; this blocks casual
 * context menus, selection, drag, and common shortcut paths.
 */
export function installContentProtection(): () => void {
  const onContextMenu = (e: Event) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const onSelectStart = (e: Event) => {
    const target = e.target as HTMLElement | null
    if (isEditable(target)) return
    e.preventDefault()
  }

  const onDragStart = (e: Event) => {
    const target = e.target as HTMLElement | null
    if (isEditable(target)) return
    e.preventDefault()
  }

  const onCopy = (e: ClipboardEvent) => {
    const target = e.target as HTMLElement | null
    if (isEditable(target)) return
    e.preventDefault()
  }

  const onKeyDown = (e: KeyboardEvent) => {
    const key = e.key.toLowerCase()
    const meta = e.ctrlKey || e.metaKey

    // DevTools / view-source / save / print / select-all / copy / cut
    if (
      e.key === 'F12' ||
      (meta && e.shiftKey && ['i', 'j', 'c'].includes(key)) ||
      (meta && ['u', 's', 'p'].includes(key)) ||
      (meta && key === 'a' && !isEditable(e.target as HTMLElement)) ||
      (meta && key === 'c' && !isEditable(e.target as HTMLElement)) ||
      (meta && key === 'x' && !isEditable(e.target as HTMLElement))
    ) {
      e.preventDefault()
      e.stopPropagation()
    }
  }

  document.addEventListener('contextmenu', onContextMenu, true)
  document.addEventListener('selectstart', onSelectStart, true)
  document.addEventListener('dragstart', onDragStart, true)
  document.addEventListener('copy', onCopy, true)
  document.addEventListener('cut', onCopy, true)
  document.addEventListener('keydown', onKeyDown, true)

  document.documentElement.classList.add('content-protected')

  return () => {
    document.removeEventListener('contextmenu', onContextMenu, true)
    document.removeEventListener('selectstart', onSelectStart, true)
    document.removeEventListener('dragstart', onDragStart, true)
    document.removeEventListener('copy', onCopy, true)
    document.removeEventListener('cut', onCopy, true)
    document.removeEventListener('keydown', onKeyDown, true)
    document.documentElement.classList.remove('content-protected')
  }
}

function isEditable(el: HTMLElement | null): boolean {
  if (!el) return false
  const tag = el.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true
  if (el.isContentEditable) return true
  return !!el.closest('input, textarea, select, [contenteditable="true"]')
}
